import { TemplateAttachment } from 'candidate_profile_redesign/shared/types';

/**
 * We get attachments 3 ways:
 * 1. From the template (default_attachments) => submitted via custom_attachment_url and custom_attachment_filename
 * 2. From the user uploading on the modal (attachments) => submitted via custom_attachment (as binary)
 * 3. From the candidate's offer letters (options.attachments) => submitted via attachments[] (as person_attach_ids)
 *
 * In order to display the offer letters on the modal, we append them to the default_attachments
 * but when we submit the form we need to separate them out again. Hence the goofy logic below
 */
export const attachmentPayload = (
  offerLetters: Array<TemplateAttachment> | null,
  defaultAttachments: Array<TemplateAttachment> | null,
  newAttachments: any
) => {
  const formData = new FormData();
  const potentialOfferLetters: string[] =
    offerLetters?.map((attachment: TemplateAttachment) => attachment.id) || [];

  // The backend expects a different payload for
  // default attachments (from template) vs custom attachments.
  // This is dumb and we we should standardize at some point.
  if (Array.isArray(defaultAttachments)) {
    //filter offer letters from the default attachments
    const offerLettersToAttach = defaultAttachments.filter((attachment) =>
      potentialOfferLetters.includes(attachment.id)
    );

    if (offerLettersToAttach.length > 0) {
      for (const attachment of offerLettersToAttach) {
        formData.append(`attachments[]`, attachment.id);
      }
    }

    //filter out the offer letters from the default attachments
    const to_attach = defaultAttachments.filter(
      (attachment) => !potentialOfferLetters.includes(attachment.id)
    );
    formData.append(
      `custom_attachment_url`,
      to_attach.map((file) => file.url).join(',')
    );
    formData.append(
      `custom_attachment_filename`,
      to_attach.map((file) => file.filename).join(',')
    );
  }

  // "attachments" becomes "custom_attachment" to match legacy backend
  if (newAttachments) {
    for (const file of newAttachments) {
      formData.append(`custom_attachment[]`, file);
    }
  }

  return formData;
};

export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'text/html',
  'image/tiff',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/png',
];

export const ADOBE_SIZE_LIMIT_IN_BYTES = 10_000_000;
